document.querySelectorAll('.faq-acc-el-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const parentElement = trigger.closest('.faq-acc-el');
    const panel = parentElement.querySelector('.faq-acc-el-descr-frame');
    const isOpen = parentElement.classList.contains('open');

    if (!isOpen) {
      parentElement.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      parentElement.classList.remove('open');
      panel.style.maxHeight = '0';
    }
  });
});
